import { Fragment } from 'react'

import { Text } from '../fuselage/blocks/text/text'
import { FlipFlop } from '../fuselage/blocks/flipflop/flipflop'
import { Floaters, Floater } from '../fuselage/blocks/floater/floater'
import { Billboard } from '../fuselage/blocks/billboard/billboard'
import { BillboardSlider } from "../fuselage/blocks/billboard-slider/billboard-slider"
import { SpeakerCarousel } from '../fuselage/blocks/speaker-carousel/speaker-carousel'
import { SpeakerCard } from '../fuselage/components/speaker-card/speaker-card'
import { SwiperSlide } from 'swiper/react'
import { ImpactFigures, ImpactFigure } from '../fuselage/blocks/impact-figures/impact-figures'
import { Video } from '../fuselage/blocks/video/video'
import { Form } from '../fuselage/blocks/form/form'


export const handleContentBlocks = ( blocks ) => {

    if ( !blocks ) return

    // console.log("content-blocks detected: ", blocks)

    const blocksHandle = process.env.NEXT_PUBLIC_SITE_HANDLE


    return (
        <Fragment>
            {blocks.map( block => {

                // text blocks
                if ( block.__typename === `${blocksHandle}ContentBlocks_text_BlockType` ) {
                    return (
                        <Text
                            key={block.id}
                            theme={block.theme} 
                            gap={'md'} 
                            columns={block.columns} 
                            maxWidth={block.maxWidth}
                            center={block.center}
                        >
                            {block.textBlocks.map( (textBlock, index) => {
                                return <div key={index} dangerouslySetInnerHTML={{__html: textBlock.body }} />
                            })}
                        </Text>
                    )
                }

                // flip-flops
                if ( block.__typename === `${blocksHandle}ContentBlocks_flipFlops_BlockType` ) {
                    return (
                        <Fragment key={block.id}>
                            {block.flipFlops.map( flipFlop => {
                                return (
                                    <FlipFlop key={flipFlop.id} theme={block.theme} hero={flipFlop.hero[0].url} flipped={block.flipStartOrder}>
                                        <div key={flipFlop.id} dangerouslySetInnerHTML={{__html: flipFlop.body }} />
                                    </FlipFlop>
                                )
                            })}
                        </Fragment>
                    )
                }

                // floaters
                if ( block.__typename === `${blocksHandle}ContentBlocks_floaters_BlockType` ) {
                    return (
                        <Floaters key={block.id} theme={block.theme} flipped={block.flipStartOrder}>
                            {block.floaters.map( floater => {
                                return (
                                    <Floater key={floater.id} hero={floater.hero[0].url}>
                                        <div dangerouslySetInnerHTML={{__html: floater.body }} />
                                    </Floater>
                                )
                            })}
                        </Floaters>
                    )
                }

                // billboard
                if ( block.__typename === `${blocksHandle}ContentBlocks_billboard_BlockType` ) {
                    return (
                        <Billboard 
                            key={block.id}
                            hero={block.hero[0]}
                            height={block.height}
                            tint={block.tint}
                            horizontalAlign={block.horizontalAlign}
                            verticalAlign={block.verticalAlign}
                            maxContentWidth={block.maxContentWidth}
                        >
                            <div dangerouslySetInnerHTML={{__html: block.body }} />
                        </Billboard>
                    )
                }

                // billboard slider
                if ( block.__typename === `${blocksHandle}ContentBlocks_billboardSlider_BlockType` ) {
                    return (
                        <BillboardSlider key={block.id}>
                            {block.slides.map( slide => {
                                return (
                                    <SwiperSlide key={slide.id} >
                                        <Billboard 
                                            hero={slide.hero[0]}
                                            height={block.height}
                                            tint={block.tint}
                                            horizontalAlign={block.horizontalAlign}
                                            verticalAlign={block.verticalAlign}
                                            maxContentWidth={block.maxContentWidth}
                                        >
                                            <div dangerouslySetInnerHTML={{__html: slide.body }} />
                                        </Billboard>
                                    </SwiperSlide>
                                )
                            })}
                        </BillboardSlider>
                    )
                }

                // impact figures
                if ( block.__typename === `${blocksHandle}ContentBlocks_impactFigures_BlockType` ) {
                    return (
                        <ImpactFigures key={block.id} theme={block.theme}>
                            {block.impactFigures.map( impact => {
                                return (
                                    <ImpactFigure key={impact.id} value={impact.figure} label={impact.label} theme={block.theme} />
                                )
                            })}
                        </ImpactFigures>
                    )
                }
                
                // video
                if ( block.__typename === `${blocksHandle}ContentBlocks_video_BlockType` ) {
                    return <Video key={block.id} theme={block.theme} maxWidth={block.maxWidth} videoUrl={block.videoShareUrl} />
                }
                
                // form
                if ( block.__typename === `${blocksHandle}ContentBlocks_hubspotForm_BlockType` ) {
                    return (
                        <Form 
                            key={block.id}
                            theme={block.theme} 
                            maxWidth={block.maxWidth}
                            portalId={block.hubspotForm[0].portalId}
                            formId={block.hubspotForm[0].formId}
                        >
                            {block.body}
                        </Form>
                    )
                }

                // profile carousel
                if ( block.__typename === `${blocksHandle}ContentBlocks_profilesCarousel_BlockType` ) {
                    return (
                        <SpeakerCarousel 
                            key={block.id}
                            heading={block.heading} 
                            text={block.text}
                            theme={'theme'}
                            ctaLink={block.ctaButton[0].buttonLink}
                            ctaLabel={block.ctaButton[0].buttonLabel}
                        >
                            {
                                block.profiles.map( profile => (
                                    <SpeakerCard
                                        key={profile.id}
                                        url={`/speakers/profile/${profile.slug}`}
                                        photoUrl={profile.avatar[0] ? profile.avatar[0].url : null }
                                        fullName={profile.title}
                                        jobTitle={profile.positions[0].jobTitle}
                                        company={profile.positions[0].organisation}
                                    />
                                ))
                            }
                        </SpeakerCarousel>
                    )
                }

                // bizzabo passes 
                if ( block.__typename === `${blocksHandle}ContentBlocks_bizzaboPasses_BlockType` ) {
                    return (
                        <section key={block.id} className='block bg-theme'>
                            <div className='container'>
                                <p className='fs-4 fw-600'>Bizzabo Passes</p>
                            </div>
                            <div>
                                {block.bizzaboPasses.map(pass => <p key={pass.id}>{pass.passName}</p>)}
                            </div>
                        </section>
                    )
                }
                


            })}
        </Fragment>
    )


}

export default handleContentBlocks